import { useState } from "react";
import { useFormik } from "formik";
import { TextField } from "@mui/material";
import * as yup from "yup";
import { HashLoader } from "react-spinners";
import { COLORS } from "../../utils/colors";
import { MainButton } from "../../components/MainButton";

const validationSchema = yup.object({
  email: yup
    .string("Enter your email")
    .email("Enter a valid email")
    .required("Email is required"),
});

function Reset({ handleScreenChange, supabaseClient }) {
  const [loading, setLoading] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [errMessage, setErrMessage] = useState("");

  const handleFormSubmit = async (values) => {
    try {
      setLoading(true);
      setErrMessage(null);

      const { error } = await supabaseClient.auth.resetPasswordForEmail(
        values.email,
        { redirectTo: process.env.REACT_APP_URL + "/new-password" }
      );

      setLoading(false);

      if (error) {
        console.log("error: ", error);

        setErrMessage(`${error}`);
        return;
      }

      setEmailSent(true);
    } catch (err) {
      setEmailSent(false);
      setLoading(false);
      setErrMessage(`${err}`);
      console.log("Failed: ", err);
    }
  };

  // create formik object to handle the form
  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => handleFormSubmit(values),
  });

  return (
    <div className="auth-container">
      <h1 className="auth-header" style={{ marginBottom: "0px" }}>
        Reset your OOVAL password
      </h1>
      <p
        id="subheader"
        style={{ margin: "10px 0px 30px", alignSelf: "center" }}
      >
        Please enter your e-mail address
      </p>
      <div className="register-form-wrapper">
        <form className="register-form" onSubmit={formik.handleSubmit}>
          <p id="subheaderBlack" style={{ marginBottom: "3px" }}>
            Your email address
          </p>
          <TextField
            fullWidth
            size="small"
            className="input"
            id="email"
            name="email"
            placeholder="richard.hendriks@hooli.com"
            value={formik.values.email}
            onChange={formik.handleChange}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
            sx={{
              "& label": { paddingLeft: (theme) => theme.spacing(1) },
              "& fieldset": {
                borderRadius: "6px",
                border: `2px solid #f0f1f5`,
                transition: ".2s ease-in-out all",
              },
            }}
          />
          {errMessage && <p className="error-message">{errMessage}</p>}
          <div style={{ height: "9px" }} />
          <MainButton
            type="submit"
            disabled={emailSent || loading}
            text={
              loading ? (
                <>
                  <HashLoader size={20} color={COLORS.grey} /> Continue
                </>
              ) : (
                "Continue"
              )
            }
            color={COLORS.black}
            textColor={COLORS.white}
            textHoverColor={COLORS.white}
            hoverColor={COLORS.mainAccent}
            shadowColor={"transparent"}
            onClickAction={() => formik.handleSubmit()}
          />
          {emailSent && !loading && (
            <p style={{ textAlign: "center", marginTop: "10px" }}>
              Email sent! Please also check your Spam inbox.
            </p>
          )}
          <br />
          <br />
          <br />
          <p className="bottom-link">
            <span onClick={() => handleScreenChange("login")}>
              Got your new password? Log in.
            </span>
          </p>
        </form>
      </div>
    </div>
  );
}

export default Reset;
